import { TriangleAlert } from "lucide-react";
import { Navigate, useParams } from "react-router";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { usePortfolioCollection, useWrapperTypes } from "@/lib/hooks/use-portfolio-collections";
import { useT } from "@/lib/i18n/use-t";

import { TableCardSkeleton } from "../skeleton-loaders";
import { T } from "./page.i18n";
import { WrapperTypesTable } from "./wrapper-types-table";

export default function WrapperTypesPage() {
  const { id } = useParams<{ id: string }>();
  const { wrapperTypes, isLoading } = useWrapperTypes(id!);
  const { collection } = usePortfolioCollection(id!);
  const t = useT(T);

  if (isLoading) {
    return <TableCardSkeleton columns={5} />;
  }

  // The tab is hidden while the feature is off — catch direct URLs too.
  if (collection && !collection.wrapperTypesEnabled) {
    return <Navigate to={`/settings/portfolios/${id}/products`} replace />;
  }

  const status = collection?.wrapperTypeStatus;

  return (
    <div className="space-y-4">
      {status && !status.hasWrapperTypes && (
        <Alert variant="warning">
          <AlertDescription className="flex items-center gap-2">
            <TriangleAlert className="h-4 w-4 shrink-0 text-warning" />
            {t.noWrapperTypesWarning}
          </AlertDescription>
        </Alert>
      )}
      <WrapperTypesTable
        portfolioCollectionId={id!}
        wrapperTypes={wrapperTypes}
        currency={collection?.currency ?? ""}
      />
    </div>
  );
}
